import { ILoading } from "../models";
import {
    GET_FUND_START,
    GET_FUND_END,
	GET_SHARE_CLASSES_END,
	TOGGLE_LOADING,
	Actions
} from "../actions";
import { safe, appendToLoading, removeFromLoading } from "../utils";
import {IDataEntity, IToggleRequest } from "../models";

export function shareClassReducer(state: IDataEntity = null, action: Actions) {
	switch (action.type) {
		case GET_SHARE_CLASSES_END:
			return action["payload"] ? action["payload"] || {} : {};
		default: return state;
	}
}



// WEBPACK FOOTER //
// ./src/client/reducers/shareClass.ts